import { NgModule } from '@angular/core';

import { SharedModule }       from '../shared/shared.module';
import { SyncXeroComponent }  from './xero.sync.component';
import { XeroErrorComponent } from './xero.error.component';

@NgModule({
  declarations: [
    SyncXeroComponent,
    XeroErrorComponent
  ],
  entryComponents: [
    SyncXeroComponent,
    XeroErrorComponent
  ],
  imports: [
    SharedModule
  ]
})
export class XeroModule {}
